import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {RootState} from '@/store'
import {ProcessState} from '@/store/modules/processes';
import {RequestPayload, ServiceApi} from '@payroll/optimus-common'
import {ActionTree} from 'vuex'

export const actions: ActionTree<ProcessState, RootState> = {

  getProcesses: ({commit, dispatch, state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getProcesses')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  downloadLoanApplication: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback,
    pathVariable
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('downloadLoanApplication')
      .setPathVariable(pathVariable)
      .post(requestorCallback)
  },

  getMemberProcessAttachment: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback, formData}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getMemberProcessAttachment')
      .setFormData(formData)
      .post(requestorCallback)
  },

  getChangesHistories: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback,
    pathVariable
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getChangesHistories')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  hasExistMoreThenOneRequest: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback,
    pathVariable
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('hasExistMoreThenOneRequest')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  withdrawalAndTransferRows: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback,
    pathVariable
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('withdrawalAndTransferRows')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },


  fetchLoanRequest: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('fetchLoanRequest')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },


    approveApplications: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('approveApplications')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    rejectApplication: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('rejectApplication')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    underExaminationApplication: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('underExaminationApplication')
            .setRequestBody(requestBody)
          .post(requestorCallback)
    },

  getLoansManagementSettings: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback,
    pathVariable
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getLoansManagementSettings')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getLoansStatusesManagementExtraDetails: ({commit, dispatch, state, rootGetters}: any, {
    requestorCallback
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getLoansStatusesManagementExtraDetails')
      .get(requestorCallback)
  },

  getAttachedFiles: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getAttachedFiles')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  createOrUpdateCompanyDocuments: ({commit, dispatch, state, rootGetters}: any, {
    requestBody,
    requestorCallback
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('createOrUpdateCompanyDocuments')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  optionalMemberLoanAttachment: ({commit, dispatch, state, rootGetters}: any, {
    requestBody,
    requestorCallback
  }: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('optionalMemberLoanAttachment')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },


  updateAttachedFiles: ({state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateAttachedFiles')
      .setRequestBody(requestBody)
      .put(requestorCallback);
  },

  updateLoanProcessPdf: ({state, rootGetters}: any, {requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateLoanProcessPdf')
      .setPathVariable(pathVariable)
      .put(requestorCallback)
  },
  exportLoansDetails: ({state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('exportLoansDetails')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  updateRequestContactInformation: ({state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateRequestContactInformation')
      .setRequestBody(requestBody)
      .put(requestorCallback)
  },

  updateProcessRequestContactInformation: ({state, rootGetters}: any, {requestorCallback, requestBody}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateProcessRequestContactInformation')
      .setRequestBody(requestBody)
      .put(requestorCallback)
  },

}
